import '@/assets/variables.scss';

import '@qsrsoft/myq-core/styles';
import 'vuetify/dist/vuetify.css';

import { router, initVueWithAuth } from '@qsrsoft/myq-core';

import { vuetify } from '@/utils/vuetify';
import { routes } from '@/routes';

import App from './App.vue';

console.log('st-front-end', '2026-02-11', 'v2');

/**
 * Loads the app
 */
async function loadApp() {
  const app = await initVueWithAuth({
    app: App,
    routes,
    vuetify,
    router,
  });

  app.mount('#app');
}

loadApp();
